/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import { Observable } from 'rxjs';
import { AbstractResourceService, JsonApiResource, QueryParams } from '@irian-ro/abstract-resource';
import { BankAccountAuditVOModel, BankAccountDtoModel, BankAccountListMeta } from '@well/domain';

@Injectable({
  providedIn: 'root'
})
export class BankAccountResourceService extends AbstractResourceService<BankAccountDtoModel,
  BankAccountDtoModel,
  any,
  any> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('bankAccountUrl'),
      BankAccountDtoModel,
      BankAccountDtoModel
    );
  }

  findAllForLegalEntityUuid(legalEntityUuid: string, query?: any, additionalParams?: any)
    : Observable<JsonApiResource<BankAccountDtoModel[], BankAccountListMeta>> {
    const queryString = new QueryParams(
      query,
      additionalParams ? additionalParams : []
    ).toString();
    return <Observable<JsonApiResource<BankAccountDtoModel[], BankAccountListMeta>>>this.httpClient?.get(`${this.url}/${legalEntityUuid}${queryString}`);
  }

  getAuditForBankAccount(uuid: string)
    : Observable<JsonApiResource<BankAccountAuditVOModel[], BankAccountListMeta>> {
    return <Observable<JsonApiResource<BankAccountAuditVOModel[], BankAccountListMeta>>>this.httpClient?.get(`${this.url}/audit/${uuid}`);
  }
}
